<template>
<div class="a-vs-b-current-game display-flex">
	<div class="teams">
      <div class="a-vs-c-host">
        <span>{{match.HomeTeam}}</span>
				<img :src="match.HomeTeamLogo" :alt="match.HomeTeamShort">
      </div>
			<div class="a-vs-c-result">
        <goal-blink :score="homeScore"/><span> : </span><goal-blink :score="awayScore"/>
			</div>
			<div class="a-vs-c-guest">
				<img :src="match.AwayTeamLogo" :alt="match.AwayTeamShort">
				<span>{{match.AwayTeam}}</span>
			</div>
	</div>
	<div class="teams-mobile">
		<div class="host">
      <goal-blink class="result" :score="homeScore"/>
			<span class="team">{{match.HomeTeam}}</span>
		</div>
		<div class="guest">
      <goal-blink class="result" :score="awayScore"/>
			<span class="guest">{{match.AwayTeam}}</span>
		</div>
	</div>
	<div class="info">
		<p>{{$t('current_round')}}: <span>{{roundNumber}}</span></p>
		<p>{{$t('ends_in')}}: <span>{{endingTime}}</span></p>
	</div>
</div>
</template>

<script>
import { eventBus } from '@/main.js'
import EventConstants from '@/constants/Events'
import TimeFormatter from '@/mixins/TimeFormatter'

export default {
  mixins: [TimeFormatter],
  props: {
    headerResult: {
      type: Object,
      required: true
    },
    currentGame: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      timerGoalChange: 1000, // 15s
      timeToEnd: ''
    }
  },
  methods: {
    onShowTimer (data) {
      this.timeToEnd = data
    },
    secondsToTimeSpan (seconds) {
      return this.secondsToTime(seconds)
    }
  },
  computed: {
    match: function () {
      return this.currentGame.Matches[0]
    },
    roundNumber: function () {
      return this.currentGame.EventID % 1000
    },
    homeScore: function () {
      return this.headerResult.HomeScore
    },
    awayScore: function () {
      return this.headerResult.AwayScore
    },
    endingTime: function () {
      return this.secondsToTimeSpan(Math.round(this.timeToEnd))
    }
  },
  created: function () {
    eventBus.$on(EventConstants.VSOCCER_SHOW_TIMER, this.onShowTimer)
  }
}
</script>
